<template>
    <div class="socialevents">
        <h2 class="card-title">Sports Section</h2>
        <p style="font-size: 20px; font-weight: 400;">Discover our diverse range of sports and activities for all skill
            levels</p>
        <div class="cards">
            <SportsCard v-for="(card, index) in dataList" :key="index" 
            :title="card.name" 
            :content="card.description.length > 400 ? card.description.substring(0, 400) + '...' : card.description"
            :image="card.image"
                @click="openDetails(card)"
                 />
        </div>
    </div>
</template>

<script setup>
import { ref, onBeforeMount  } from "vue";
import SportsCard from "./CommonCard/SportsCard.vue";
import axios from 'axios';
import { useRouter } from 'vue-router';

const router = useRouter();
//let base_url = process.env.VUE_APP_BASE_LIVE_URL
const dataList = ref('');
//const dataImage = ref('');

// Array of card data
// const cards = ref([
//   { title: "Tennis", content: "", image: new URL("../assets/images/sports/bart.png", import.meta.url).href },
//   { title: "Darts", content: "", image: new URL("../assets/images/sports/darts.png", import.meta.url).href },
//   { title: "Squash Section", content: "", image: new URL("../assets/images/sports/squash.png", import.meta.url).href },
//   { title: "Billiards & Snooker", content: "", image: new URL("../assets/images/sports/pool.png", import.meta.url).href },
//   { title: "Table Tennis", content: "", image: new URL("../assets/images/sports/tableTennis.png", import.meta.url).href },
//   { title: "Other Games", content: "", image: new URL("../assets/images/sports/others.png", import.meta.url).href }
// ]);

onBeforeMount( async () => {
  await listSportSection();
})

const listSportSection = async () => {
  try {
    const response = await axios.get('/sport_section_lists.php', { });
    dataList.value = response.data.data;
    
  //   response.data.data.forEach(el => {
  //   const card = cards.value.find(c => c.title === el.name);
  //   if (card) {
  //       card.content = el.title;
  //   } 
  // });
   
  } catch (error) {
    console.error(error.message);
  }
};

const openDetails = (card)=>{
  router.push({
    name: "SportSectionDetail",
    params: {
      title: card.name
    }
  });
}

</script>

<style scoped lang="scss">
.socialevents {
    max-width: 80%;
    margin: auto;
    margin-top: 5rem;
}

.btn-active {
    background-color: #ED4E24;
    color: #fff;
    font-weight: 500;
    font-family: "Open Runde", sans-serif;
    border: 2px solid #ED4E24;
    border-radius: 60px;
    width: 103px;
}

.btn-not-active {
    background-color: #fff;
    border: 2px solid #9B9A9A;
    color: #9B9A9A;
    font-weight: 500;
    font-family: "Open Runde", sans-serif;
    border-radius: 60px;
    width: 103px;

}

.buttons {
    display: flex;
    gap: 20px;
    justify-content: center;
    align-items: center;
    overflow-x: auto;
}
.card-title{
    font-size: 48px; 
    font-weight: 400;
}
.cards {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 20px;
    margin-top: 5rem;
    cursor: pointer;
}

@media (max-width: 768px) {
    .socialevents {
        max-width: 100%;
        margin: auto;
        margin-top: 2rem;
    }

    .cards {
        display: grid;
        grid-template-columns: repeat(1, 1fr);
        gap: 20px;
        margin-top: 5rem;
    }

    .card-title{
        font-size: 35px; 
    }
}
</style>
